{
  "eyebrow": "Planınızı seçin",
  "title": "Ekibinizin çalışma şekline uygun plan.",
  "sub": "Her planda 30 gün ücretsiz deneme. Kredi kartı gerekmez. İstediğiniz zaman iptal edin.",
  "bill": {
    "month": "Aylık",
    "year": "Yıllık",
    "save": "~17% tasarruf"
  },
  "fam": {
    "time": "Zaman ve operasyon",
    "project": "Proje ve maliyet kontrolü"
  },
  "compare": "Tüm özellikleri karşılaştır",
  "compareHide": "Karşılaştırmayı gizle",
  "included": "Dahil",
  "select": "{{plan}} seç",
  "selected": "Seçildi",
  "recommended": "En popüler",
  "pricePerMonth": "/ kullanıcı / ay",
  "pricePerYear": "/ kullanıcı / yıl",
  "base": "temel / ay",
  "admins": "2 yönetici dahildir",
  "continueCta": "{{plan}} ile devam et",
  "continuePick": "Devam etmek için bir plan seçin",
  "catalogError": "Fiyat kataloğu kullanılamıyor. En güncel fiyatları yüklemek için tekrar deneyin.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Uyumluluk ve basit takip",
    "timeProBest": "Ekip operasyonları",
    "projectBasicBest": "Proje ve maliyet kontrolü",
    "projectProBest": "Gelişmiş proje yönetimi",
    "feat": {
      "timeBasic": {
        "timeTracking": "Zaman kaydı",
        "absencesHolidays": "Devamsızlıklar ve tatiller",
        "transport": "Ulaşım kayıtları",
        "workLocations": "İş yerleri ve GPS",
        "mobileApp": "Saha çalışanları için mobil uygulama"
      },
      "timePro": {
        "everythingTime": "Time Basic'in tüm özellikleri",
        "overtime": "Fazla mesai kaydı",
        "scheduling": "Vardiya planlama",
        "documents": "Çalışan belgeleri",
        "officeOps": "Ofis işlemleri (etkinlik günlüğü, düzeltmeler)",
        "addonsAvailable": "Mevcut eklentiler: proje takibi, VTT",
        "internalMessaging": "Dahili mesajlaşma (şirket sohbeti)"
      },
      "projectBasic": {
        "everythingTime": "Time Basic'in tüm özellikleri",
        "projects": "Maliyet kontrollü projeler",
        "extras": "Ek iş ve ek malzeme",
        "subcontractors": "Taşeron yönetimi",
        "checkInOut": "Çalışan giriş / çıkış",
        "internalMessaging": "Dahili mesajlaşma (şirket sohbeti)"
      },
      "projectPro": {
        "everythingAll": "Time Pro + Project Basic'in tüm özellikleri",
        "projectTransport": "Proje bazlı taşımacılık",
        "fullSuite": "Tam üretkenlik paketi",
        "prioritySupport": "Öncelikli destek",
        "internalMessaging": "Dahili mesajlaşma (şirket sohbeti)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Tüm özellikleri karşılaştırın",
    "subtitle": "Her planın içerdiği her şey, yan yana.",
    "cat": {
      "timeAttendance": "Zaman & devam",
      "projectCost": "Proje & maliyet kontrolü",
      "support": "Destek"
    },
    "val": {
      "upTo4": "4’e kadar",
      "unlimited": "Sınırsız",
      "soon": "Yakında",
      "optional": "İsteğe bağlı",
      "years5": "5 yıl",
      "years10": "10 yıl"
    },
    "row": {
      "mobileDesktop": "Mobil ve masaüstü uygulama",
      "gpsCheckin": "GPS ile tek dokunuşla giriş",
      "holidayAbsenceOvertime": "İzin, devamsızlık ve fazla mesai",
      "teamMembers": "Ekip üyeleri",
      "workLocations": "İş konumları",
      "registrationsPerMonth": "Kayıtlar / kullanıcı / ay",
      "irregularMap": "Haritada düzensiz giriş/çıkış",
      "expenseManagement": "Masraf yönetimi",
      "employeeDocuments": "Çalışan belgeleri",
      "openApi": "Açık API",
      "navigation": "İş sahalarına navigasyon",
      "projectManagement": "Proje yönetimi (bütçe)",
      "subprojects": "Alt projeler",
      "subcontractorManagement": "Taşeron yönetimi",
      "extraWorkMaterials": "Ek iş ve malzemeler",
      "transportProjects": "Projelere bağlı ulaşım",
      "fullSuite": "Tam verimlilik paketi",
      "prioritySupport": "Öncelikli destek",
      "schedulingMessaging": "Planlama · Mesajlaşma · Bildirimler",
      "languages12": "12 dilde kullanılabilir",
      "manualTransport": "Manuel ulaşım mesafesi",
      "reportsExcel": "Raporlar ve Excel'e aktarma",
      "frontendLocations": "Uygulama kullanıcılarının oluşturduğu konumlar",
      "checkInWork": "Check-in/out@work (Belçika)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Proje açıklamaları ve fotoğraflar",
      "dataStorage": "Veri saklama"
    }
  }
}
